// Initialize Google Maps
$(document).ready(function() {
  if (typeof ticketLocations !== 'undefined' && ticketLocations !== null) {
    
    let mapCenterLat = 39.5;
    let mapCenterLong = -98.35;

    if (ticketLocations.length == 1) {
      mapCenterLat = ticketLocations[0]['lat']
      mapCenterLong = ticketLocations[0]['long']
    }

    var map = new google.maps.Map(document.getElementById('map'), {
      zoom: zoom,
      center: new google.maps.LatLng(mapCenterLat, mapCenterLong),
      mapTypeId: google.maps.MapTypeId.ROADMAP
    });

    var infowindow = new google.maps.InfoWindow();

    var marker, i;

    for (i = 0; i < ticketLocations.length; i++) {  
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(ticketLocations[i]['lat'], ticketLocations[i]['long']),
        map: map
      });

      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          infowindow.setContent(ticketLocations[i]['city']);
          infowindow.open(map, marker);
        }
      })(marker, i));
    }

    if (ticketLocations.length > 1) {
      let todaysDate = new Date();
      let counter = 0;

      ticketLocations.sort(function(a,b) {
        return new Date(a.date) - new Date(b.date);
      });

      $.each(ticketLocations, function(index, data) {
        if (counter < 5) {
          var inputDate = new Date(data['date']);

          if(inputDate.setHours(0,0,0,0) >= todaysDate.setHours(0,0,0,0)) {
            $('.custom-maps__container tbody').append("<tr><td>" + data['date'] + "</td><td>" + data['city'] + "</td><td>" + data['venue'] + "</td></tr>");
            counter++;
          }      
        }
      });
    }
  }
});
